/** Sigorta / evrak talep — Outlook ve mailto taslak açma. */

function htmlToText(html) {
    if (!html) return "";
    return String(html)
        .replace(/<\s*br\s*\/?>/gi, "\n")
        .replace(/<\/\s*(p|div|li|h[1-6])\s*>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\r\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
}

function normalizeRecipients(raw) {
    return String(raw || "")
        .split(/[,;]+/)
        .map((s) => s.trim())
        .filter(Boolean);
}

/** Outlook masaüstü: alıcılar noktalı virgül ile ayrılır. */
export function normalizeOutlookFields(fields = {}) {
    const toList = normalizeRecipients(
        fields.to ?? fields.alicilar ?? fields.mail_to ?? fields.email,
    );
    const ccList = normalizeRecipients(fields.cc);
    const bodyRaw =
        fields.body ??
        fields.mail_plain_text ??
        fields.govde ??
        fields.sablon_html ??
        fields.mail_body ??
        fields.mesaj ??
        "";
    const body = htmlToText(bodyRaw).replace(/\n/g, "\r\n");
    return {
        to: toList.join(";"),
        cc: ccList.join(";"),
        subject: String(fields.subject ?? fields.konu ?? fields.mail_subject ?? "").trim(),
        body,
    };
}

export function resolveSigortaMailFields(row, overrides = {}) {
    const merged = { ...(row || {}), ...overrides };
    const f = normalizeOutlookFields({
        alicilar: merged.alicilar ?? merged.email ?? merged.mail_to,
        cc: merged.cc,
        konu: merged.konu ?? merged.mail_subject ?? merged.baslik,
        mail_plain_text:
            merged.mail_plain_text ??
            merged.sablon_html ??
            merged.mail_body ??
            merged.mesaj,
    });
    return {
        to: f.to.replace(/;/g, ","),
        cc: f.cc.replace(/;/g, ","),
        subject: f.subject,
        body: f.body,
    };
}

export function buildMailtoComposeUrl(fields) {
    const f = normalizeOutlookFields(fields);
    const toCsv = f.to.replace(/;/g, ",");
    const parts = [];
    if (f.cc) parts.push(`cc=${encodeURIComponent(f.cc.replace(/;/g, ","))}`);
    if (f.subject) parts.push(`subject=${encodeURIComponent(f.subject)}`);
    if (f.body) parts.push(`body=${encodeURIComponent(f.body)}`);
    const qs = parts.length ? `?${parts.join("&")}` : "";
    return `mailto:${toCsv}${qs}`;
}

/** Yeni Outlook masaüstü (Windows) — to;cc;subject;body */
export function buildMsOutlookComposeUrl(fields) {
    const f = normalizeOutlookFields(fields);
    const parts = [];
    if (f.to) parts.push(`to=${encodeURIComponent(f.to)}`);
    if (f.cc) parts.push(`cc=${encodeURIComponent(f.cc)}`);
    if (f.subject) parts.push(`subject=${encodeURIComponent(f.subject)}`);
    if (f.body) parts.push(`body=${encodeURIComponent(f.body)}`);
    return `ms-outlook://compose?${parts.join("&")}`;
}

function launchUrl(url) {
    window.location.href = url;
}

export function openSigortaMailCompose(row, overrides = {}) {
    launchUrl(buildMailtoComposeUrl(resolveSigortaMailFields(row, overrides)));
}

/**
 * Outlook'ta alıcı, CC, konu ve gövde dolu taslak açar.
 * API'den gelen outlook: { to, cc, subject, body } varsa doğrudan kullanılır.
 */
export function openOutlookCompose(fields) {
    const src =
        fields?.outlook && typeof fields.outlook === "object"
            ? fields.outlook
            : fields;
    const normalized = normalizeOutlookFields({
        to: src.to,
        cc: src.cc,
        subject: src.subject ?? src.konu,
        body: src.body ?? src.mail_plain_text ?? src.govde,
        alicilar: src.alicilar,
        konu: src.konu,
        mail_plain_text: src.mail_plain_text ?? src.govde,
    });
    if (!normalized.to) {
        throw new Error("Alıcı e-posta tanımlı değil");
    }
    launchUrl(buildMsOutlookComposeUrl(normalized));
}

/** .eml dosyasını indirip Outlook'ta aç (en güvenilir yöntem). */
export function downloadEmlFile(emlText, filename = "evrak_talep.eml") {
    const blob = new Blob([emlText], { type: "message/rfc822;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function buildSigortaMailto(row, overrides = {}) {
    return buildMailtoComposeUrl(resolveSigortaMailFields(row, overrides));
}
